import { render, staticRenderFns } from "./CampusInfo.vue?vue&type=template&id=836b212a&scoped=true&"
import script from "./CampusInfo.vue?vue&type=script&lang=ts&"
export * from "./CampusInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CampusInfo.vue?vue&type=style&index=0&id=836b212a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836b212a",
  null
  
)

export default component.exports